module.exports = __webpack_public_path__ + "static/media/29BDOS10.b7dfa429.jpg";